import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import {
  HeaderRow,
  HeaderCell,
  Cell,
  Row,
  SortableCell,
  Table,
  Body,
  Head,
} from '@zendeskgarden/react-tables';

const {
  custom_dark_blue: customDarkBlue,
  custom_border_grey: customBorderGrey,
} = variables;

export const PublicProductsTableWrapper = styled('div')``;

export const StyledTable = styled(Table)`
  border-radius: 8px;
  border: none !important;

  @media (min-width: 1100px) {
    && .cell_api_internal_pressure {
      width: 10%;
    }
    && .cell_button {
      width: 5%;
    }
    && .cell_collapse_pressure {
      width: 10%;
    }
    && .cell_wall {
      width: 12%;
    }
    && .cell_inside_diameter {
      width: 12%;
    }
  }
  @media (max-width: 1000px) {
    && .cell_name {
      width: 32%;
    }
    && .cell_button {
      display: none !important;
    }
  }
`;

export const TableBody = styled(Body)`
  border: 1px solid ${customBorderGrey};
  border-top: none;
  overflow: hidden;
  background-color: #fff;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  ${(props) =>
    props.pagination
      ? `
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  `
      : ''}
`;

export const TableHead = styled(Head)`
  overflow: hidden;
  height: 64px;
  background-color: #fff;
`;

export const TableHeaderRow = styled(HeaderRow)`
  border: 1px solid ${customBorderGrey};
  overflow: hidden;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  height: 100%;
`;

export const TableHeaderCell = styled(HeaderCell)`
  ${(props) =>
    props.grey
      ? `
    background: #eaecf1;
  `
      : ''}
  h3 {
    text-transform: uppercase;
    letter-spacing: 1.1px;
    font-size: 11px;
    font-weight: 500;
    color: #76899e;
    display: flex;
    align-items: center;
  }
`;

export const TableSortableCell = styled(SortableCell)`
  h3 {
    text-transform: uppercase;
    letter-spacing: 1.1px;
    font-size: 11px;
    font-weight: 500;
    color: #76899e;
    display: flex;
    align-items: center;
  }
`;

export const TableRow = styled(Row)`
  border-color: rgba(118, 137, 158, 0.06);
  position: relative;
`;

export const TableCell = styled(Cell)`
  padding: 13px 12px;
  min-width: 0;
  align-self: stretch;
  h3 {
    color: ${customDarkBlue};
    &.with-suffix {
      display: flex;
      min-width: 0;
      .suffix {
        padding-left: 4px;
      }
    }
  }
  & > div {
    max-width: 100%;
  }
  ${(props) =>
    props.fontSize === 'SM'
      ? `
    h3 {
      font-size: 12px !important;
      line-height: 17px;
    }
    h4 {
      font-size: 11px !important;
      line-height: 17px;
    }
  `
      : ''}

  ${(props) =>
    props.grey
      ? `
    background: #eaecf1;
  `
      : ''}

  ${(props) =>
    props.link
      ? `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    a {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  `
      : ''}
`;
